import { render, staticRenderFns } from "./ExpandedTranshipmentManagementCard.vue?vue&type=template&id=c8ad9416"
import script from "./ExpandedTranshipmentManagementCard.vue?vue&type=script&lang=js"
export * from "./ExpandedTranshipmentManagementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports